import { Box } from '@chakra-ui/react';
import React from 'react'

type TickIconProps = {
    isTicked?: boolean;
    isIncomplete?: boolean;
}

const TickIcon: React.FC<TickIconProps> = ({ isTicked, isIncomplete }) => {
    return (
        <Box h={6} w={6} borderRadius="100px" border={`2px solid ${isIncomplete? "#D5DBE3" : "#FF7E6B"}`} bg={isTicked ? "#FF7E6B" : "white"}>
            {
                isTicked &&
                <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.5 14.5C5.5 14.5 7 14.5 9 18C9 18 14.5588 8.83333 19.5 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            }
        </Box>
    )
}

export default TickIcon;